import React from 'react';
import { useGetLiveSessionQuery } from '../../../../generated/core-api/graphql-react-query';
import { SessionInfoContext, SessionInfoContextProps } from './useSessionInfoContext';

export default function SessionInfoContextProvider({ children }: { children: React.ReactNode }) {
  const [sessionId, setSessionId] = React.useState<string | null>(null);
  const [endCause, setEndCause] = React.useState<SessionInfoContextProps['endCause']>(null);
  const [endingSession, setEndingSession] = React.useState<string | null>(null);

  const session = useGetLiveSessionQuery({ input: { id: sessionId ?? '' } }, { enabled: !!sessionId });

  React.useEffect(() => {
    if (!sessionId) {
      setEndCause(null);
    }
  }, [sessionId]);

  const value = React.useMemo(() => ({
    sessionId,
    setSessionId,
    session: session.data?.getSession,
    endCause,
    setEndCause,
    setEndingSession,
    endingSession,
  }), [sessionId, session.data?.getSession, endCause, endingSession]);
  return (
    <SessionInfoContext.Provider value={value}>
      {children}
    </SessionInfoContext.Provider>
  );
}
